import React from 'react';
import { Menu, Bell, Search, RefreshCw } from 'lucide-react';

const Header = ({ onMenuClick, sensors }) => {
  const activeSensors = sensors.filter(s => s.status === 'active').length;
  const warningSensors = sensors.filter(s => s.status === 'warning').length;
  const offlineSensors = sensors.filter(s => s.status === 'offline').length;

  const getTimeAgo = (dateString) => {
    const now = new Date();
    const date = new Date(dateString);
    const diffInMinutes = Math.floor((now - date) / (1000 * 60));
    
    if (diffInMinutes < 1) return 'À l\'instant';
    if (diffInMinutes < 60) return `Il y a ${diffInMinutes} min`;
    if (diffInMinutes < 1440) return `Il y a ${Math.floor(diffInMinutes / 60)} h`;
    return `Il y a ${Math.floor(diffInMinutes / 1440)} j`;
  };

  const lastUpdate = sensors.length > 0 
    ? Math.max(...sensors.map(s => new Date(s.last_update).getTime()))
    : Date.now();

  return (
    <header className="sticky top-0 z-30 glass-effect border-b border-white/10">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Mobile menu button */}
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 rounded-lg hover:bg-white/10 text-slate-600 hover:text-slate-900"
          >
            <Menu className="h-6 w-6" />
          </button>

          {/* Search bar */}
          <div className="flex-1 max-w-md mx-4">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-slate-400" />
              <input
                type="text"
                placeholder="Rechercher un capteur..."
                className="w-full pl-10 pr-4 py-2 bg-white/50 border border-white/20 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary-500 focus:bg-white/80 text-slate-700 placeholder-slate-400"
              />
            </div>
          </div>

          {/* Stats & Actions */}
          <div className="flex items-center space-x-4">
            {/* Status indicators */}
            <div className="hidden sm:flex items-center space-x-4 px-4 py-2 bg-white/50 rounded-xl border border-white/20">
              <div className="flex items-center space-x-1">
                <div className="h-2 w-2 bg-success-500 rounded-full animate-pulse-slow"></div>
                <span className="text-sm font-medium text-slate-700">{activeSensors}</span>
              </div>
              {warningSensors > 0 && (
                <div className="flex items-center space-x-1">
                  <div className="h-2 w-2 bg-warning-500 rounded-full animate-pulse-slow"></div>
                  <span className="text-sm font-medium text-slate-700">{warningSensors}</span>
                </div>
              )}
              {offlineSensors > 0 && (
                <div className="flex items-center space-x-1">
                  <div className="h-2 w-2 bg-danger-500 rounded-full"></div>
                  <span className="text-sm font-medium text-slate-700">{offlineSensors}</span>
                </div>
              )}
            </div>

            {/* Notifications */}
            <button className="relative p-2 bg-white/50 rounded-xl hover:bg-white/80 transition-colors duration-200 border border-white/20">
              <Bell className="h-5 w-5 text-slate-600" />
              {(warningSensors > 0 || offlineSensors > 0) && (
                <span className="absolute -top-1 -right-1 h-4 w-4 bg-danger-500 text-white text-xs font-medium rounded-full flex items-center justify-center">
                  {warningSensors + offlineSensors}
                </span>
              )}
            </button>

            {/* Refresh button */}
            <button className="p-2 bg-white/50 rounded-xl hover:bg-white/80 transition-colors duration-200 border border-white/20 group">
              <RefreshCw className="h-5 w-5 text-slate-600 group-hover:rotate-180 transition-transform duration-500" />
            </button>

            {/* Last update indicator */}
            <div className="hidden md:flex items-center space-x-2 px-3 py-2 bg-white/30 rounded-xl border border-white/20">
              <div className="h-2 w-2 bg-primary-500 rounded-full animate-pulse"></div>
              <span className="text-xs font-medium text-slate-600">
                {getTimeAgo(new Date(lastUpdate).toISOString())}
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;